import React, { Component } from 'react';
import Loading from '../common/Loading/Loading';


class Callback extends Component {
    render() {
        return <Loading />;
    }
}

export default Callback;


// WEBPACK FOOTER //
// ./src/authentication/Callback.js